import { ControlType } from '../entities/controlType';

/**
 * A control with no allowedTaxpayerTypes (null/absent/empty) is available to everyone.
 * A restricted control is only eligible when the taxpayer's type is known AND listed.
 * A restricted control with an unknown taxpayer type is NOT eligible (avoid leaking it).
 */
export function isControlEligible(controlType: ControlType, taxpayerType?: string): boolean {
  const allowed = controlType?.allowedTaxpayerTypes;
  if (!allowed || allowed.length === 0) {
    return true;
  }
  return !!taxpayerType && allowed.includes(taxpayerType);
}

export function filterEligibleControls(controlTypes: ControlType[], taxpayerType?: string): ControlType[] {
  if (!controlTypes) {
    return [];
  }
  return controlTypes.filter(ct => isControlEligible(ct, taxpayerType));
}
